import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'

const CBETH_URL = 'https://api.exchange.coinbase.com/wrapped-assets/cbeth'

export const cbethFetcher: YieldFetcher = {
  label: 'CBETH',
  fetch: async () => {
    try {
      const res = await fetch(CBETH_URL, {
        headers: {
          'User-Agent': '1delta/yields',
          'Content-Type': 'application/json',
        },
      }).then((r) => r.json())
      return { CBETH: apyToAprPercent(res.apy) * 100 }
    } catch (e) {
      console.log('CBETH failed', e)
      return { CBETH: 0 }
    }
  },
}
